import '../../App.css';
import axios from 'axios';
import React, { useState, useEffect, useRef, useContext ,useLayoutEffect} from 'react';
import Chart from 'chart.js';
import ErrorMessage from "../../common/ErrorMessage/ErrorMessage";
import { UserContext } from "../../context/UserContext";
import { BASE_URL } from "../../baseUrl"

function BarChart() {

  /**************************************/
  /*General const*/

  /*const for load strategies*/
  const [login, setLogin] = useContext(UserContext);
  const [strategies, setStrategies] = useState([]);
  const [clientBio, setClientBio] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedStrategy, setSelectedStrategy] = useState(null);
  const selectRef = useRef(null);
  const [strategydata, setStrategyData] = useState([]);
  const [maxYear, setMaxYear] = useState(null)
  const [Cyear, setCyear] = useState(null);
  const chartRef = useRef(null); // Add a ref for the chart canvas

  /*const for data strategy modal*/
  
  const [activeModal, setActiveModal] = useState(false);
  const [modalFlag, setModalFlag] = useState(null);
  const [isStrategySelected, setIsStrategySelected] = useState(false); // New state variable
  const [selectedBarData, setSelectedBarData] = useState({ year: null, value: null, idEntry:null });

  /**************************************/
  /*Code to load the strategies */
  const getGenericInfo = async ()=>{
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + login.token,
        },
    };
  
    const response = await fetch(BASE_URL + "/api/bargraph/", requestOptions);
      if (!response.ok) {
          setErrorMessage("Something went wrong. Couldn't load the bargraph info");
      } else {
          const data = await response.json();
          console.log("***generic info*****")
          console.log(data)
          setStrategies(data.commitments);
          setClientBio(data.client);
          setLoaded(true);
      }
  }
  
  const getStrategydata = async(id_strategy)=>{
    const requestOptions = {
      method: "GET",
      headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + login.token,
      },
    };

    const response = await fetch(BASE_URL + `/api/bargraph/${id_strategy}`, requestOptions);
      if (!response.ok) {
          setErrorMessage("Something went wrong. Couldn't load the bargraph data");
      } else {
          const data = await response.json();
          console.log("************************")
          console.log("***strategy data*****")
          console.log(data)
          setStrategyData(data);
          const maxYear = Math.max(...data.map(item => item.Year));
          setMaxYear(maxYear)
      }
  };

  const handleStrategyChange = (event) => {
    const strategyId = event.target.value;
    console.log("****value de strategy id********")
    console.log(strategyId)
    const strategy = strategies.find(commitment => commitment.ID_Strategy.toString() === strategyId);
    setSelectedStrategy(strategy);
    getStrategydata(strategyId);
    setIsStrategySelected(true); // Set the state to indicate that a strategy has been selected
  };

  const handleArrowClick = (direction) => {
    const selectElement = selectRef.current;
    if (direction === 'left' && selectElement.selectedIndex > 0) {
        selectElement.selectedIndex -= 1;
    } else if (direction === 'right' && selectElement.selectedIndex < selectElement.options.length - 1) {
        selectElement.selectedIndex += 1;
    }
    const strategyId = selectElement.value;
    const strategy = strategies.find(commitment => commitment.ID_Strategy.toString() === strategyId);
    setSelectedStrategy(strategy);
    getStrategydata(strategyId)
  };

  /**************************/
  /*Original bargraph code */
  useEffect(() => {
  let chart;

    if (strategydata.length !== 0 && chartRef.current) {

      console.log("*****************")
      console.log("USE EFFECT CALLED")
      console.log(strategydata)
      let validfromdate = strategydata[0].ValidFrom
      let validfrom = parseInt(validfromdate.split("-")[0])
      let validtodate = strategydata[0].ValidTo
      let validto = parseInt(validtodate.split("-")[0])

      const years_ = [];
      setCyear(validfrom);

      for (let i = validfrom; i <= validto; i++) {
        years_.push(i);
      }

      console.log(years_)
     
      let LineData = (Array(years_.length).fill(null))
      let LineData_IDEntry = (Array(years_.length).fill(null))
      let BarColors = (Array(years_.length).fill("rgba(54, 162, 235, 0.2)"))
      let YearList = (years_.slice(years_.findIndex((index) => index >= validfrom)))

      // Calculate the new lineData from the fetched strategies
      LineData = years_.map(year => {
        const strategyForYear = strategydata.find(strategy => strategy.Year === year);
        return strategyForYear ? strategyForYear.Value : null;
      });
      console.log("this is the new line data")
      console.log(LineData)
      
      //Calculate the new lineData "ID ENTRY" from strategies
      LineData_IDEntry = years_.map(year => {
        const strategyForYear_IDEntry = strategydata.find(strategy => strategy.Year === year);
        return strategyForYear_IDEntry ? strategyForYear_IDEntry.ID_DataEntry : null;
      });
      console.log("this is the new ID_ENTRY")
      console.log(LineData_IDEntry)
      
      const YrstoEnd = () => {
        //return 2050 - Cyear;
        return validto-validfrom
      };

      const DivFactorBars = () => {
        return 1 / YrstoEnd();
      };

      const CYIndexLoc = () => {
        return years_.findIndex((index) => index >= validfrom);
      };

      const listBars = [];
      let i = 0;
      while (i <= validto - validfrom) {
        const value = (i * DivFactorBars() * 100).toFixed(2);
        listBars.push(parseFloat(value));
        i++;
      }

      if (chartRef.current) {
        const ctx = chartRef.current.getContext("2d"); // Use the ref to get the chart canvas

        chart = new Chart(ctx, {
          type: "bar",
          data: {
            labels: YearList,
            datasets: [
              {
                type: "bar",
                label: "Expected Progress",
                data: listBars,
                backgroundColor: BarColors.slice(CYIndexLoc(validfrom)),
                borderColor: "rgba(54, 162, 235, 1)",
                borderWidth: 1,
              },
              {
                fill: true,
                type: "line",
                label: "Progress Reported",
                data: LineData,
                borderColor: "rgba(255, 239, 109, 0.5)",
              },
            ],
          },

          options: {
            onClick: function(evt, activeElements) {
              if (activeElements.length === 0) return;
              const firstPoint = this.getElementAtEvent(evt)[0];
              if (firstPoint) {
                const index = firstPoint._index;
                const idEntry = LineData_IDEntry[CYIndexLoc(validfrom) + index]

                if (idEntry !== null) {
                  const value = LineData[CYIndexLoc(validfrom) + index];
                  const year = years_[CYIndexLoc(validfrom) + index];
                  handleBarClick(year, value, idEntry);
                }
              }
            }
          }

        });


      
        chartRef.current.chart = chart; //Store the chart instance in the ref
      }
    } else {
      window.scrollTo(0, 0);
      getGenericInfo()
    }

    // Cleanup function to destroy the chart instance when the component unmounts
    return () => {
    if (chart) {
      chart.destroy();
    }
  };
  },[strategydata]);

  const handleReportNewData= () => {
    if (selectedStrategy) {
      setModalFlag(1); // Set the flag value for the "Report" button
      handleModal();
    }
  };

  const handleBarClick = (year, value, idEntry) => {
    setSelectedBarData({ year, value, idEntry }); // Set the selected year and value for the clicked bar
    setModalFlag(2)
    handleModal()
    //handleEditData()
    //setActiveModal(true); // Open the modal
  };

  const handleModal = () => {
    setActiveModal(!activeModal);
    /*possibel:GetGeneric info*/
  };

  const handleBarChartReload = () => {
    // code to reload or refresh the bar chart
    getStrategydata(selectedStrategy.ID_Strategy)
 }

  return (
  
  <>
    
    
    </>);
}

export default BarChart;